import { apiSlice } from "./apiSlice";
export const workflowConfigrationSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllWorkflowConfigration: builder.query({
            query: (params) => ({
                url: `WorkflowConfiguration`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllWorkflowConfiguration"],
        }),
        addWorkflowConfiguration: builder.mutation({
            query: (body) => ({
                url: `WorkflowConfiguration`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllWorkflowConfiguration']
        }),
        getWorkflowConfigration: builder.query({
            query: (id) => ({
                url: `WorkflowConfiguration/${id}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllWorkflowConfiguration"],
        }),
        updateWorkflowConfiguration: builder.mutation({
            query: (body) => ({
                url: `WorkflowConfiguration`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllWorkflowConfiguration']
        }),

    }),
});

export const { 
    useLazyGetAllWorkflowConfigrationQuery, 
    useGetWorkflowConfigrationQuery, 
    useAddWorkflowConfigurationMutation,
    useUpdateWorkflowConfigurationMutation } = workflowConfigrationSlice;
